import React, { PureComponent } from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import request from '../../utils/Request'
import UTM from '../../utils/UTM'
import { API_WIDGETDATA_URI } from '../../../constants'
import Start from './StyledStart'
import Icon from './StyledIcon'
import List from './StyledList'
import Progress from './StyledProgress'
import ProgramLink from './StyledProgramLink'
import { TextContainer, ProgressContainer } from './StyledContainers'

const RELOAD_INTERVAL_MS = 120000

export default class TvProgram extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      boxes: props.widget.boxes
    }
    this.refreshingInterval = null
  }

  componentDidMount () {
    this.refreshingInterval = setInterval(() => {
      const {
        widget: {
          name,
          boxesConfig
        }
      } = this.props
      const requestConfig = {
        url: API_WIDGETDATA_URI,
        method: 'post',
        data: {
          widgetConfig: {
            [name]: {
              boxesConfig
            }
          }
        }
      }

      request(requestConfig).then(response => {
        this.setState({
          boxes: response.data[name].boxes
        })
      }).catch(() => {})
    }, RELOAD_INTERVAL_MS)
  }

  componentWillUnmount () {
    clearInterval(this.refreshingInterval)
  }

  render () {
    const {
      widget,
      widget: {
        utmContent,
        utmMedium,
        utmSource
      }
    } = this.props
    const {
      boxes
    } = this.state

    if (!boxes.length) return null

    return (
      <WidgetContainer widget={widget}>
        <List>
          { boxes.map((box, index) => {
            const {
              channel: {
                icon
              },
              program: {
                start,
                title,
                progress,
                location
              }
            } = box
            const utmParams = {
              utmContent,
              utmMedium,
              utmSource,
              utmTerm: `position-${index + 1}`
            }
            const utmLink = new UTM(location).getUTMLink(utmParams)

            return (
              <li key={box.guid}>
                <TextContainer>
                  <Icon src={`${STATICS_PATH}${icon}`} />
                  <Start>
                    { start }
                  </Start>
                  <ProgramLink href={utmLink}>
                    { title }
                  </ProgramLink>
                </TextContainer>
                <ProgressContainer>
                  <Progress width={progress} />
                </ProgressContainer>
              </li>
            )
          })}
        </List>
      </WidgetContainer>
    )
  }
}
